// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"kY-z","subtitle":"lY-z","wrapper":"mY-z","leftArrow":"nY-z","rightArrow":"oY-z"};